export default __webpack_public_path__ + "static/media/coresanscr25it-webfont.27d3c20e.woff2";